"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuperEllipse = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const super_ellipse_1 = require("@alfalab/core-components/icon-view/super-ellipse");
const hooks_1 = require("@alfalab/hooks");
const child_1 = require("../child");
/**
 * Оборачивает графику в эллипс
 *
 * [Макет](https://www.figma.com/design/OiFlIdSpmFYZ5zsFGWA3TD/Web-%3A%3A-Alfa-Online-Composites?node-id=102575-522685)
 */
const SuperEllipse = (_a) => {
    var { children, imageUrl: imageUrlProp, backgroundColor: backgroundColorProp, text, colorText, border = true, size = 48 } = _a, restProps = __rest(_a, ["children", "imageUrl", "backgroundColor", "text", "colorText", "border", "size"]);
    // Для src намеренно используется || ""
    // тк значение по умолчанию не применяется к src когда в нем null
    const imageLoadingState = (0, hooks_1.useImageLoadingState)({ src: imageUrlProp || '' });
    const imageFailed = imageLoadingState === 'error';
    const backgroundColor = imageFailed && !text ? undefined : backgroundColorProp;
    const imageUrl = imageFailed || !imageUrlProp ? undefined : imageUrlProp;
    return ((0, jsx_runtime_1.jsx)(super_ellipse_1.SuperEllipse, Object.assign({}, restProps, { border: border, size: size, backgroundColor: backgroundColor, imageUrl: imageUrl, children: (0, jsx_runtime_1.jsx)(child_1.Child, { hasImage: Boolean(imageUrl), imageLoadingFailed: imageFailed, text: text, colorText: colorText, size: size, children: children }) })));
};
exports.SuperEllipse = SuperEllipse;
